import React from "react";
import { HeroReuse } from "../../components/common/HeroReuse";
import VacancyDetail from "../../components/sections/careers/VacancyDetail";
import { vacancyDescription } from "../../components/sections/careers/careerData";

const VacancyDetails = () => {
  return (
    <>
      <HeroReuse 
        Subtitle="CAREERS"
        Title="DevOps/Data Engineer (AWS)"
        type={['Remote','Full-Time']}
      />
      <VacancyDetail content={vacancyDescription} />
    </>
  );
};

export default VacancyDetails;
